import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Calendar } from 'lucide-react';
import { motion } from 'framer-motion';

/**
 * Floating "Book Now" button — fixed bottom-right on every page.
 * - Mobile: larger pill (touch-friendly), pulsing ring, tap-scale feedback
 * - Desktop: pill with icon + label, shine sweep on hover
 */
const MobileStickyBooking = () => {
  const { t } = useLanguage();

  return (
    <div
      className="fixed bottom-6 right-5 lg:bottom-8 lg:right-8 z-40"
      data-testid="floating-book-now-wrapper"
    >
      {/* Pulsing halo ring (drawing the eye) */}
      <motion.span
        aria-hidden
        className="absolute inset-0 rounded-full bg-[#A14223]"
        animate={{ scale: [1, 1.28, 1], opacity: [0.45, 0, 0.45] }}
        transition={{ duration: 2.2, repeat: Infinity, ease: 'easeOut' }}
      />

      <motion.div
        whileTap={{ scale: 0.94 }}
        whileHover={{ scale: 1.04 }}
        transition={{ type: 'spring', stiffness: 400, damping: 20 }}
      >
        <Link
          to="/booking"
          data-testid="floating-book-now"
          aria-label={t.nav.bookNow}
          className="relative group inline-flex items-center gap-2.5 rounded-full bg-[#A14223] text-[#F5F0E8] px-5 py-3.5 lg:px-6 lg:py-4 shadow-[0_18px_40px_-6px_rgba(161,66,35,0.55)] hover:shadow-[0_22px_50px_-4px_rgba(161,66,35,0.75)] transition-shadow duration-300 overflow-hidden font-body tracking-[0.2em] uppercase text-[11px] lg:text-xs"
        >
          {/* Sheen sweep on hover */}
          <span
            aria-hidden
            className="pointer-events-none absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-[900ms] ease-out"
            style={{
              background:
                'linear-gradient(100deg, transparent 30%, rgba(255,255,255,0.18) 50%, transparent 70%)',
            }}
          />
          <Calendar size={17} className="relative shrink-0" />
          <span className="relative whitespace-nowrap">
            {t.nav.bookNow}
          </span>
        </Link>
      </motion.div>
    </div>
  );
};

export default MobileStickyBooking;
